module.exports = __webpack_public_path__ + "img/1.8bbc3862.jpg";